import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import markdownit from 'markdown-it';
import 'github-markdown-css/github-markdown-light.css';
import axios from 'axios';
import { BOffcanvas,BContainer,BButton,BRow,BCol,BListGroup,BListGroupItem } from "bootstrap-vue-next";
import HeaderBar from '@/components/HeaderBar.vue';

export default {
  name: 'Home',
  components: {
    Loading,BOffcanvas,BContainer,BButton,BRow,BCol,BListGroup,BListGroupItem,HeaderBar
  },

  // 共通関数
  //mixins: [netutils],

  // ローカルデータ変数
  data() {
    return {
      // メッセージ
      message: {
        is_alert: false,
        variant: "",
        message: "",
      },
      // ローディング
      loader: {
        is_loading: false,
        is_full_page: true,
      },
      // バインドデータ
      bind_data: {
        markdownit: null, //マークダウンオブジェクト
        markdowntext: "", //HTML化したテキスト
      },
      // ローカルデータ
      local_data: {
      },
      // 状態データ
      state_data: {
      }
    }
  },

  // 既定計算
  computed: {
    currentLocale() {
      return this.$i18n ? this.$i18n.locale : 'ja';
    }
  },

  watch: {
    currentLocale() {
      this.loadMarkdown();
    }
  },

  // インスタンス初期化後
  created: function(){
    this.bind_data.markdownit = new markdownit();
  },
  // インスタンス破棄後
  destroyed: function() {
  },
  // インスタンスマウント後
  mounted: async function(){
    let href = window.location.href;
    console.log("Home:href="+href);
    await this.loadMarkdown();
  },

  // ローカル関数
  methods: {
    async loadMarkdown() {
      this.loader.is_loading = true;
      try {
        const lang = this.currentLocale === 'en' ? 'en' : 'ja';
        const res = await axios.get(`/description_${lang}.md`);
        this.bind_data.markdowntext = this.bind_data.markdownit.render(res.data);
      } catch (e) {
        console.error("Failed to load markdown:", e);
      } finally {
        this.loader.is_loading = false;
      }
    },
    home(){
      // 画面遷移
      this.$router.push({ path:'/Home' });
    },
    Guide(){
      // 画面遷移
      this.$router.push({ path:'/Guide' });
    },
    privacy_policy(){
      // 画面遷移
      this.$router.push({ path:'/PrivacyPolicy' });
    },
    terms_of_service(){
      // 画面遷移
      this.$router.push({ path:'TermsOfService' });
    },
  }
}
